import { useEffect, useState } from "react";
import isEmpty from "lodash/isEmpty";
import first from "lodash/first";
import useProductVeryFirstSize from "./useProductVeryFirstSize";
import useIsProductSingleSize from "@/components/product/hooks/useIsProductSingleSize";
import { Product } from "@/services/productService";
import useProductSizeTypes from "./useProductSizeTypes";
import { ProductVariant, SelectedSize } from "@/routes/pdp/types";

const useProductSizeSelectionFlow = (product: Product) => {
  const productSizeTypes = useProductSizeTypes(product);
  const productVeryFirstSize = useProductVeryFirstSize(product);
  const isProductSingleSize = useIsProductSingleSize(product);
  const productSizes = product.sizes || [];

  const [selectedSizeFullData, setSelectedSizeFullData] =
    useState<SelectedSize>({
      sizeType: first(productSizeTypes) || {},
      size: isProductSingleSize ? productVeryFirstSize : {}
    });

  const setActiveSizeType = (
    sizeType: TextAttributeField | EmptyObject,
    manualSize?: ProductVariant | EmptyObject
  ) => {
    let size = selectedSizeFullData.size;
    if (sizeType && !isEmpty(size)) {
      const typeSizes = productSizes.find(
        size => size.sizeType.key === sizeType.key
      ).variants;
      size = typeSizes
        ? typeSizes.find(
            variant => variant.sizeId === selectedSizeFullData.size.sizeId
          )
        : selectedSizeFullData.size;
    }
    setSelectedSizeFullData({ sizeType, size: manualSize ? manualSize : size });
  };

  useEffect(() => {
    product?.id && setActiveSizeType(first(productSizeTypes), {});
    if (isProductSingleSize) {
      setSelectedSizeFullData({
        sizeType: first(productSizeTypes),
        size: productVeryFirstSize
      });
    }
  }, [product?.id]);

  return {
    activeSizeType: selectedSizeFullData.sizeType,
    setActiveSizeType,
    selectedSizeFullData,
    setSelectedSizeFullData
  };
};

export default useProductSizeSelectionFlow;
